// extracted by mini-css-extract-plugin
export default {"small_italic_text":"XU","wrapper":"YU","page":"ZU","topblock":"aV","nextBtn":"bV","bottomnav":"cV","MyClassEnterDone":"eV","topname":"fV","text":"gV"};
    if(module.hot) {
      // 1726593107523
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  